import SocialMediaLinks from './SocialMediaLinks.vue';

export default SocialMediaLinks;
